import { render } from "./cp_frontpage.vue?vue&type=template&id=62159768"
import script from "./cp_frontpage.vue?vue&type=script&lang=js"
export * from "./cp_frontpage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__